import { Component } from '@angular/core'

@Component({
    selector: 'cvc-tag-group',
    templateUrl: './tag-group.component.html',
    styleUrls: ['./tag-group.component.less'],
    standalone: false
})
export class CvcTagGroupComponent {
  constructor() {}
}
